import { network } from 'services/network';
import { useMutation } from 'react-query';
import qs from 'qs';

const mutationFn = ({ id, contractId }: QueryParams) => {
    const querystring = qs.stringify({ id, contractId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/deleteStoredFilterBulkAssignOrRemoveTags${querystring}`;

    return network.get(url).then((response) => response.data);
};

export const useMutationDeleteStoredFilterBulkAssignOrRemoveTags = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    id: string;
    contractId: number;
}
